const utils = {

  // returns the next logical name derived from the 'lastestName'
  // @todo: dit werkt op een of andere manier niet meer
  nextName: function (latestName) {
    console.log('latestName', latestName);
    let result = '';
    if (isNaN(latestName)) {
      console.log('string', latestName.charCodeAt(0));
      result = String.fromCharCode(latestName.charCodeAt(0) + 1);
    } else {
      console.log('number');
      result = parseInt(latestName, 10) + 1;
    }
    console.log('result', result);
    return result;
  },

  // returns a date-string for e.g. created_at, updated_at
  nowDateString: function () {
    let now = new Date();
    return now.toISOString();
  }

};

export { utils };